import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ThirdFloorDataGrid from '../Grids';


export default function ReportData( { selectedReport, data, schema } ) {
    if ( !selectedReport || selectedReport.showRawData === false ) {
        return null;
    }

    return (
        <Container fluid>
            <Row>
                <Col className='fw-bold'>Raw Data</Col>
            </Row>
            <Row style={ { height: '400px' } }>
                <ThirdFloorDataGrid gridKey={selectedReport.id} schema={schema} registry={ {} } rows={data} />  
            </Row>
        </Container>
                    
    );
}